import { render, staticRenderFns } from "./centerMemberTagNothing.vue?vue&type=template&id=579ccced&scoped=true&"
import script from "./centerMemberTagNothing.vue?vue&type=script&lang=js&"
export * from "./centerMemberTagNothing.vue?vue&type=script&lang=js&"
import style0 from "./centerMemberTagNothing.vue?vue&type=style&index=0&id=579ccced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ccced",
  null
  
)

export default component.exports